// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__KHIxG","hello":"Tooltip_hello__V8iO_","trigger":"Tooltip_trigger__N4IYT"};